import moment from "moment";

const paidMonth = moment().format("MMMM YYYY");

export const withholdPaymentsFilterInitialValues = {
	paidMonth,
};

export const payoutsFilterInitialValues = {
	paidMonth,
};

export const unknownMidFilterInitialValues = {
	paidMonth,
};

export const agentReportsFilterInitialValues = {
	paidMonth,
};

export const agentOfficeReportsFilterInitialValues = {
	paidMonth,
};

export const missingScheduleAResidualFilterInitialValues = {
	paidMonth,
};

export const calculationFilterInitialValues = {
	paidMonth,
};

export const adjustmentsFilterInitialValues = {
	paidMonth,
};
